import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

import useResize from 'hooks/useResize';
import { sortInASpecificOrder } from 'utils/helpers';

import PaymentMethod from './PaymentMethod';
import styles from './PaymentMethods.css';


const MOBILE_WIDTH_THRESHOLD = 1024;
const paymentMethodsOrdersByCountry = {
  'gb': ['CC', 'PP', 'BT', 'PS'],
  'pl': ['PZ', 'CC', 'PP', 'CR', 'PS'],
  'br': ['CC', 'PP', 'IX'],
};

function PaymentMethods({ methods, selected, handleSelection, user }) {
  const expandedLayout = methods.length < 6 && methods.length % 2 === 0;
  const [width] = useResize();
  const mobileView = isMobile || width <= MOBILE_WIDTH_THRESHOLD;

  const wrapperClasses = classnames({
    [styles.paymentMethodsWrapper]: true,
    [styles.expandedLayout]: Boolean(expandedLayout),
  });

  const order = paymentMethodsOrdersByCountry[user.realCountry];
  if (order) {
    methods.sort((a, b) =>
      sortInASpecificOrder(a.value, b.value, order));
  }

  return methods.length > 0 ? (
    <div className={wrapperClasses}>
      {methods.map((method) => (
        <PaymentMethod
          key={method.value}
          handleSelection={handleSelection}
          isSelected={method.value === selected.value}
          method={method}
          mobileView={mobileView}
        />
      ))}
    </div>
  ) : null;
}

PaymentMethods.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  methods: PropTypes.array.isRequired,
  selected: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default PaymentMethods;
